import React from "react";
import Navbar from "../components/Navbar";
import Header from "../components/Header";
import About from "../components/About";
import Skills from "../components/Skills";
import EduExp from "../components/EduExp";
import Portfolio from "../components/Portfolio";
import MobileApps from "../components/MobileApps";
import MediumBlog from "../components/MediumBlog";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";

const Home = () => {
  return (
    <div className="relative min-h-screen w-full overflow-x-hidden bg-paper text-gray-900 antialiased transition-colors duration-300 dark:bg-ink-900 dark:text-white">
      <div className="pointer-events-none fixed inset-0 z-0 opacity-60 dark:opacity-100">
        <div className="absolute inset-0 bg-grid-faint [background-size:48px_48px] dark:bg-grid-faint-dark" />
      </div>
      <div className="pointer-events-none fixed inset-0 z-0 bg-noise opacity-[0.02] dark:opacity-[0.035]" />

      <Navbar />

      <main className="relative z-10">
        <Header />
        <About />
        <Skills />
        <EduExp />
        <Portfolio />
        <MobileApps />
        <MediumBlog />
        <Contact />
      </main>

      <Footer />
      <BackToTop />
    </div>
  );
};

export default Home;